import { IGetReminderCount, IGetReminder, IGetReminderDetails, IReleaseAllReminder } from "./types";

export const getReminderCountSlr = (state: any): IGetReminderCount => state.reminders.getReminderCount;
export const getReminderSlr = (state: any): IGetReminder => state.reminders.getReminder;
export const getReminderDetailsSlr = (state: any): IGetReminderDetails => state.reminders.getReminderDetails;
export const releaseAllReminder = (state: any): IReleaseAllReminder => state.reminders.releaseAllReminder;
